/** No-op CalendarPort adapter. Reports not-connected for everything. */
export function createNoneCalendar() {
  return {
    async status() { return { status: "not_connected", vendor: "none" }; },
    async findAvailableSlots() { return []; },
    async bookMeeting() { throw new Error("CALENDAR_NOT_CONFIGURED"); },
    async cancelMeeting() {},
    async listEvents() { return []; },
  };
}
